import { IBaseModel } from "./abstract/ibaseModel.interface";


export class CustomerPriceList implements IBaseModel {
    id: number;
    customerId: number;
    priceListId: number;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/models/customerPriceList.model.ts